<template>
  <div class="video-container">
    <div class="video" v-if="video.number">
      <video-box
          ref="video_index"
          :video="video"
        ></video-box>
    </div>
    <div class="video" v-else>
      <img v-if="$i18n.locale==='en-US'" src="@/assets/home_images/video_en.png" />
      <img v-else src="@/assets/home_images/video.png" />
    </div>
  </div>
</template>
<script>
import cameraApi from "@/api/device/camera";
import videoBox from '@/components/video/VideoBox.vue'
export default {
  name: 'Video', 
  components: {
    videoBox
  },
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          number: '',
          channel: 1
        };
      },
    }
  },
  data() {
    return {
      video: {
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: ''
      }
    }
  },
  watch: {
    itemData: {
      handler(newVal, oldVal) {
        if(newVal&&oldVal){
          if(newVal.number&&newVal.number!=oldVal.number){
            this.getCameraInfo()
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getCameraInfo () {
      if (!this.itemData.number) {
        return
      }
      cameraApi.cameraInfo({
        number: this.itemData.number,
        channel: this.itemData.channel
      }).then((res) => {
        if (res.data.code === 1000) {
          const {title, number, camera_type, channel, access_token} = res.data.data
          this.video = {
            title: title,
            number: number,
            camera_type: camera_type,
            channel: channel,
            access_token: access_token,
          }
        }
      });
    },
  }
}
</script>
<style lang='less'>
.video-container{
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding: 20px;
  .video {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
    text-align:center;
    img {
      width: 100%;
      height: auto;
    }
    iframe{
      margin: 0;
      padding: 0;
      border:0;
    }
  }
}
</style>
